<template>
  <div class="add-technologyBom">
    <el-card class="table_searchbar">
      <el-row>
        <el-col :span="24" style="text-align: center; margin-bottom: 20px">
          <span class="el-dialog__title">查看工艺BOM</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="W ? 5 : 5">
          <span class="title">工艺编码：</span>
          <span class="value">{{ addForm.technologyCode }}</span>
        </el-col>

        <el-col :span="W ? 5 : 5">
          <div>
            <span class="title">物料编码：</span>
            <span class="value" style="word-break: break-all">{{ addForm.materialCode }}</span>
          </div>
        </el-col>
        <el-col :span="W ? 5 : 5">
          <div>
            <span class="title">物料名称：</span>
            <span class="value" style="word-break: break-all">{{ addForm.materialName }}</span>
          </div>
        </el-col>
        <el-col :span="W ? 8 : 8">
          <div>
            <span class="title">规格型号：</span>
            <span class="value" style="width: 360px; word-break: break-all">{{ addForm.specification }}</span>
          </div>
        </el-col>
      </el-row>

      <el-row style="margin: 20px 0 10px 0">
        <el-col :span="W ? 5 : 5">
          <div>
            <span class="title">物料类型：</span>
            <span class="value">{{ parseType(addForm.type) }}</span>
          </div>
        </el-col>
        <el-col :span="W ? 5 : 5">
          <div>
            <span class="title">工艺路线：</span>
            <span class="value">{{ addForm.routeName }}</span>
          </div>
        </el-col>
        <el-col :span="W ? 5 : 5">
          <div>
            <span class="title">机组名称：</span>
            <span class="value">{{ addForm.factoryModelNames }}</span>
          </div>
        </el-col>

        <el-col :span="W ? 9 : 9">
          <el-checkbox disabled style="margin: 0 0 0 10px" v-model="addForm.isTestTech">是否试制工艺</el-checkbox>
        </el-col>
      </el-row>

      <el-table :data="procedureList" style="width: 100%" @row-click="handdle" :row-style="rowClass" :maxHeight="356">
        <el-table-column label="序号" min-width="50px" prop="procedureIndex"></el-table-column>
        <el-table-column label="工序编码" min-width="80px" prop="procedureCode"></el-table-column>
        <el-table-column label="工序名称" min-width="80px" prop="procedureName"></el-table-column>
        <el-table-column label="机组编码" min-width="100px" prop="factoryModelCode"></el-table-column>
        <el-table-column label="机组名称" min-width="100px" prop="factoryModelName"></el-table-column>

        <!-- <el-table-column label="设备类型" min-width="100px" prop="deviceTypeId" :formatter="parseDeviceType"></el-table-column> -->
        <el-table-column label="默认工价" min-width="80px" prop="defaultSalary"></el-table-column>
        <el-table-column label="是否报工" min-width="80px">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.isNeedReport" disabled></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card class="table-card">
      <el-tabs type="border-card" class="eltabs" v-model="activeName" @tab-click="itemChange">
        <el-tab-pane label="工序物料" name="procedureMaterialList">
          <el-table :data="procedureList[index].procedureMaterialList" :maxHeight="140">
            <el-table-column label="序号" type="index" min-width="50"></el-table-column>
            <el-table-column label="物料编码" prop="materialCode"></el-table-column>
            <el-table-column label="物料名称" prop="materialName"></el-table-column>
            <el-table-column label="物料类型" prop="itemType">
              <template slot-scope="scope">
                {{ parseType(scope.row.itemType) }}
              </template>
            </el-table-column>
            <!-- <el-table-column label="父物料比例" prop=""></el-table-column> -->
            <el-table-column label="替代物料" prop="replaceMateria" :formatter="parseReplace"></el-table-column>
            <el-table-column label="成材率(%)" prop="yield"></el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="工装夹具" name="toolFixtureList">
          <el-table :data="procedureList[index].toolFixtureList" :maxHeight="140">
            <el-table-column label="序号" type="index" min-width="50"></el-table-column>
            <!-- <el-table-column label="夹具类型"></el-table-column> -->
            <el-table-column label="夹具组编码" prop="toolGroupCode"></el-table-column>
            <el-table-column label="夹具组名称" prop="toolGroupName"></el-table-column>
            <el-table-column label="型号"></el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="工艺参数" name="technologyParameterList">
          <el-table :data="procedureList[index].technologyParameterList" :maxHeight="140">
            <el-table-column label="序号" type="index" min-width="50"></el-table-column>
            <el-table-column label="设备名称" prop="deviceName"></el-table-column>
            <el-table-column label="设备编码" prop="deviceCode"></el-table-column>
            <el-table-column label="最小转移批量" prop="minBatch"></el-table-column>
            <el-table-column label="节拍(单位:秒/次)" prop="productionCycle">
              <template slot="header">
                <span>节拍(单位:秒/次)</span>
                <el-tooltip effect="dark" content="未填时,默认为5秒/次" placement="top-start">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="日标准产能" prop="standardCapacity"></el-table-column>
            <el-table-column label="前置时间(单位:小时)" prop="prepareTime">
              <template slot="header">
                <span>前置时间(单位:小时)</span>
                <el-tooltip effect="dark" content="未填时,默认为2小时" placement="top-start">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="工价" prop="everySalary"></el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="SOP文档" name="sopDocList">
          <el-table :data="procedureList[index].sopDocList" :maxHeight="140">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="SOP名称" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.fileId != null">
                  <div style="width: 80px; height: 70px; padding-top: 10px">
                    <el-tooltip class="item" effect="dark" :content="scope.row.fileName" placement="bottom-end">
                      <div class="file-icon-container" :style="{ backgroundImage: `url(${scope.row.filePath})` }" @click="showFile(scope.row.fileUrl)"></div>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="SOP文档名称" prop="">
              <template slot-scope="scope">
                <span v-if="scope.row.fileId != null">{{ scope.row.fileName }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="自定义参数" name="technologyParameterInfoList">
          <el-table :data="procedureList[index].technologyParameterInfoList" :maxHeight="140">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="参数名称" prop="parameterName"></el-table-column>
            <el-table-column label="参数值" prop="parameterValue"></el-table-column>
            <el-table-column label="下限值" prop="lowerLimit"></el-table-column>
            <el-table-column label="上限值" prop="upperLimit"></el-table-column>
            <el-table-column label="描述信息" prop="description"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <el-row style="margin-top: 20px">
        <el-col :span="24" style="text-align: center">
          <el-button type="primary" v-if="itemData.state == 0 && permission.btn_technology_check" @click="checkTechnology">审核</el-button>
          <el-button @click="cancelAdd">返 回</el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    itemData: Object
  },
  data() {
    return {
      factoryList: [], //唯一
      addForm: {
        technologyCode: "",
        materialId: null,
        routeName: "",
        factoryModelNames: "",
        procedureList: [
          {
            procedureIndex: 1,
            factoryModelId: null,
            procedureName: "",
            procedureCode: "",
            needScanCode: false,
            procedureMaterialList: [],
            toolFixtureList: [],
            technologyParameterList: [],
            sopDocList: [],
            technologyParameterInfoList: [],
            index: 0
          }
        ]
      },
      index: 0,
      activeName: "procedureMaterialList",
      procedureList: [
        {
          procedureIndex: 1,
          factoryModelId: null,
          procedureName: "",
          procedureCode: "",
          needScanCode: false,
          procedureMaterialList: [],
          toolFixtureList: [],
          technologyParameterList: [],
          sopDocList: [],
          technologyParameterInfoList: [],
          index: 0
        }
      ],
      W: true,

      materiaList: [],
      templateOptions: [],
      toolGroupList: [], //唯一
      deviceList: [],
      subMateriaList: [],
      deviceTypeOptions: [],
      selectIndex: null,
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },

  mounted: async function() {
    await this.getTechnologyInfoByTechnologyId(this.itemData.id);
    this.addForm.procedureList = this.procedureList;
    // this.materiaList = await this.loadMaterialList();
    // this.getListFactoryModel()
    // this.loadToolGroupList()
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
    this.loadDeviceTypeList();
  },
  methods: {
    getTechnologyInfoByTechnologyId: async function(id) {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/technology/getTechnology",
        type: "sync",
        params: { id }
      });
      this.addForm = data;
      this.addForm.id = this.itemData.id;
      data.procedureList.forEach((item, index) => {
        item.index = index;
        if (item.sopDocList) {
          item.sopDocList.forEach(s => {
            if (s.fileName) {
              s.filePath = this.getFilePath(s.fileName);
            }
            s.fileUrl = s.url;
          });
        }
      });
      this.procedureList = data.procedureList;
      this.addForm.procedureList = this.procedureList;
    },
    parseReplace(row) {
      if (row.replaceMaterialId) {
        return `${row.replaceMaterialName}/${row.replaceMaterialCode}`;
      }
    },
    parseType(type) {
      if (type == 0) {
        return "产品";
      } else if (type == 1) {
        return "零件";
      } else if (type == 2) {
        return "原材料";
      }
    },
    parseDeviceType(row) {
      return (this.deviceTypeOptions.find(item => item.id == row.deviceTypeId) || {}).deviceType;
    },
    async loadDeviceTypeList() {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/device/listDeviceType",
        type: "sync",
        params: {}
      });
      if (code == 0) {
        this.deviceTypeOptions = data;
      } else {
        this.$message.error(msg || message);
      }
    },
    itemChange(ev) {},

    handdle(row, column, event) {
      if (row.index < this.procedureList.length) {
        this.index = row.index;
      } else {
        this.index = 0;
      }
    },

    rowClass({ row, columnIndex }) {
      if (row.index == this.index) {
        return { "background-color": "rgb(109, 183, 238)", cursor: "pointer" };
      } else {
        return { cursor: "pointer" };
      }
    },

    //通过模板查询工序数据
    async getProcedureByTemplateId(technologyTemplateId) {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/technologyTemplate/getTemplateMsg",
        type: "sync",
        params: { technologyTemplateId }
      });
      if (code == 0) {
        return data;
      } else {
        this.$message.error(msg || message);
      }
    },

    async templateChange(ev) {
      let data = await this.getProcedureByTemplateId(ev);
      if (this.procedureList.length > 0) {
        this.$confirm("此操作将删除现有工序数据, 是否继续?", "提示", {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(
          () => {
            this.$refs.mySelect.handleClose();
            this.changeProcedureData(data);
          },
          err => {
            this.$refs.mySelect.handleClose();
          }
        );
      } else {
        this.changeProcedureData(data);
      }
    },

    changeProcedureData(data) {
      data.templateFlowDtos.forEach((item, index) => {
        item.procedureMaterialList = [{}];
        item.toolFixtureList = [{}];
        item.technologyParameterList = [{}];
        item.sopDocList = [{}];
        item.technologyParameterInfoList = [{}];
        item.index = index;
        item.procedureIndex = index + 1;
      });
      this.procedureList = data.templateFlowDtos;
    },

    async selectFactoryModel(ev) {
      await this.loadDeviceList(ev);
    },

    materialSelect() {
      this.$set(this.addForm, "type", (this.materiaList.find(item => item.id == this.addForm.materialId) || {}).itemType);
      this.loadSubMaterialList(this.addForm.materialId);
    },

    subMaterialSelect(ev, scope, type) {
      if (type == 0) {
        this.$set(scope.row, "materialType", (this.subMateriaList.find(item => item.id == scope.row.materialId) || {}).itemType);
      } else {
        this.$set(scope.row, "materialId", null);
      }
    },

    async typeSelect() {
      this.$set(this.addForm, "materialId", null);
      this.materiaList = await this.loadMaterialList();
    },

    async loadDeviceList(id) {
      let { data, msg, code, message } = await this.$RequestUtil.getAsync({
        url: "/api/device/getDeviceListByFactoryModelId",
        params: { id }
      });
      if (code == 0) {
        this.deviceList = data;
      } else {
        this.$message.error(msg || message);
      }
    },

    addLists() {
      let len = this.procedureList.length;
      this.procedureList.push({
        procedureIndex: len + 1,
        procedureMaterialList: [{}],
        toolFixtureList: [{}],
        technologyParameterList: [{}],
        sopDocList: [{}],
        technologyParameterInfoList: [{}],
        index: len
      });
    },
    delLists(index) {
      log(111);
      this.procedureList.splice(index, 1);
      return false;
      log(this.procedureList, 8888);
    },

    // 获取物料名称下拉选项
    async loadMaterialList(materialName, materialCode, itemType) {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/select/listMaterial",
        params: { materialName, materialCode, itemType: this.addForm.type }
      });
      if (res.code != 0) {
        this.$message.error(res.msg || res.message);
        return;
      }
      return res.data;
    },
    async remoteMethod(materialName, materialCode, itemType) {
      this.materiaList = await this.loadMaterialList(materialName, materialCode, itemType);
    },

    //加载物料下的子物料
    async loadSubMaterialList(id) {
      let { data, msg, code, message } = await this.$RequestUtil.getAsync({
        url: "/api/material/getNextBomMaterialList",
        params: { id }
      });
      if (code == 0) {
        this.subMateriaList = data;
      } else {
        this.$message.error(msg || message);
      }
    },

    // 获取工作中心下拉选项
    async getListFactoryModel(Name, Code) {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/select/listFactoryModel",
        params: { Name, Code }
      });
      if (res.code != 0) {
        this.$message.error(res.msg || res.message);
        return;
      }
      this.factoryList = res.data;
    },

    async loadToolGroupList() {
      let { data, msg, code, message } = await this.$RequestUtil.getAsync({
        url: "/api/toolGroup/getList",
        params: {}
      });
      if (code == 0) {
        this.toolGroupList = data;
      } else {
        this.$message.error(msg || message);
      }
    },

    // 审核
    checkTechnology() {
      this.$confirm("确认审核通过该工艺?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/technology/checkTechnology",
          params: { id: this.itemData.id },
          success: res => {
            if (res.code == 0) {
              this.$message({ type: "success", message: "审核通过!" });
              this.cancelAdd();
            } else {
              this.$message({ type: "error", message: res.msg || res.message });
            }
          }
        });
      });
    },

    cancelAdd() {
      this.$parent.initTable();
      this.$parent.showPage = 1;
    },

    // 删除
    delProLists(index) {
      this.procedureList[this.index].procedureMaterialList.splice(index, 1);
    },

    // 添加
    addProLists(index) {
      this.procedureList[this.index].procedureMaterialList.push({});
    },

    // 删除
    delTooLists(index) {
      this.procedureList[this.index].toolFixtureList.splice(index, 1);
    },
    // 添加
    addTooLists(index) {
      this.procedureList[this.index].toolFixtureList.push({});
    },
    // 删除
    delTecLists(index) {
      this.procedureList[this.index].technologyParameterList.splice(index, 1);
    },
    // 添加
    addTecLists(index) {
      this.procedureList[this.index].technologyParameterList.push({});
    },
    // SOP删除
    delSopLists(index) {
      this.procedureList[this.index].sopDocList.splice(index, 1);
    },
    // SOP添加
    addSopLists(index) {
      this.procedureList[this.index].sopDocList.push({});
    },
    addParameterList() {
      this.procedureList[this.index].technologyParameterInfoList.push({});
    },
    delParameterList() {
      this.procedureList[this.index].technologyParameterInfoList.splice(index, 1);
    },
    // 获取数量
    getProNumInput(ev, index) {
      this.procedureMaterialList[index].amount = ev;
    },
    // 选择SOP文件
    selectUploadFile: function(scope, fileType) {
      if (!this.permission.btn_fileSys_list) {
        this.$message.warning("您暂无文件管理权限");
        return;
      }

      this.selectIndex = scope.$index;
    },
    uploadComplete(res) {
      if (res.data) {
        this.$set(this.procedureList[this.index].sopDocList[this.selectIndex], "fileId", res.data.id);
        this.$set(this.procedureList[this.index].sopDocList[this.selectIndex], "fileName", res.data.fileName);
        this.$set(this.procedureList[this.index].sopDocList[this.selectIndex], "fileUrl", res.data.url);
        this.$set(this.procedureList[this.index].sopDocList[this.selectIndex], "filePath", this.getFilePath(res.data.fileName));
      }
    },
    showFile: function(url) {
      if (!this.permission.btn_file_get) {
        this.$message({
          type: "error",
          message: `抱歉，您暂无文件读取权限`
        });
        return false;
      }
      if (!url) {
        this.$message.warning("当前文件不存在");
        return;
      }
      let index = url.lastIndexOf(".");
      let ext = url.substr(index + 1).toLowerCase();
      //可直接被浏览器打开的文件类型
      let arr = ["pdf", "png", "jpg", "svg", "txt", "html", "js", "art", "au", "aiff", "xbf", "jpeg"];
      if (arr.includes(ext)) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    },
    deleteFile: function(scope, type) {
      if (!this.permission.btn_file_upload) {
        this.$message({
          type: "error",
          message: `抱歉，您暂无文件删除权限`
        });
        return false;
      }
      this.$confirm("此操作将删除该文件, 是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$set(scope.row, "fileName", "");
        this.$set(scope.row, "fileId", null);
        this.$set(scope.row, "fileUrl", "");
        this.$set(scope.row, "filePath", "");
      });
    },
    getFilePath(fileName) {
      if (!fileName) {
        return;
      }
      let filePath = "";
      let arr = fileName.split(".");
      let suffix = arr[arr.length - 1];

      switch (true) {
        case suffix == "pdf" || suffix == "pptx":
          filePath = "../../../static/img/pdf.png";
          break;
        case suffix == "png" || suffix == "jpg" || suffix == "svg":
          filePath = "../../../static/img/pic.png";
          break;
        case suffix == "txt" || suffix == "doc" || suffix == "docx":
          filePath = "../../../static/img/txt.png";
          break;
        default:
          filePath = "../../../static/img/file.png";
      }
      return filePath;
    }
  }
};
</script>

<style scoped>
.eltabs {
  margin-top: 30px;
}
.file-icon-container {
  width: 36px;
  height: 45px;
  margin-top: 0px;

  background-size: cover;
  position: relative;
  cursor: pointer;
}

.file-delete {
  position: absolute;
  top: -6px;
  left: 28px;
  width: 15px;
  height: 15px;
  background-image: URL("../../../static/img/delete.png");
  background-size: cover;
  cursor: pointer;
}
@media screen and (max-width: 1440px) {
  .add-technologyBom {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}
.add-technologyBom .title {
  font-size: 14px;
}
</style>
<style>
.add-technologyBom .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: none;
}
</style>



// WEBPACK FOOTER //
// src/views/TechnologyBOM/ViewTechnology.vue